import { useState } from "react";
import { Button, Col, Modal, Row, Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  adminResetPassAction,
  teacheResetPassAction,
  teacherChangeRoleAction,
  teacherDeleteAction,
  teacherSuspendAction,
} from "../Redux/Action/TeacherAction";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  ClassCollectionDeleteAction,
  collectiondeleteAction,
} from "../Redux/Action/CollectionAction";
import {
  parentResetPasswordAction,
  studentDeleteAction,
  studentResetPasswordAction,
} from "../Redux/Action/StudentAction";
import {
  ClassDeleteAction,
  classdetailsAction,
} from "../Redux/Action/ClassAction";
import {
  adminChangeRoleAction,
  adminDeleteAction,
} from "../Redux/Action/ManageAdminAction";

const ConfirmModal = ({
  isModalOpen,
  handleConfirmClose,
  data,
  selectedType,
  extraFunction,
  message,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [canUpdateYearGroups, setCanUpdateYearGroups] = useState(true);
  const [canManageAdmins, setCanManageAdmins] = useState(true);

  const handleDelete = async () => {
    try {
      const res = await dispatch(teacherDeleteAction(data?._id));
      if (res?.payload?.statusCode == 200) {
        navigate("/teachers");
        toast.success("Teacher Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSuspend = async () => {
    try {
      const value = {
        id: data._id,
      };
      const res = await dispatch(teacherSuspendAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/teachers");
        toast.success("Teacher Suspended Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteCollection = async () => {
    try {
      const res = await dispatch(collectiondeleteAction(data));
      if (res?.payload?.statusCode == 200) {
        navigate("/collections");
        toast.success("collection Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteAdmin = async () => {
    try {
      const res = await dispatch(adminDeleteAction(data?._id));
      if (res?.payload?.statusCode == 200) {
        navigate("/manage-admin");
        toast.success("Admin Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteOthersCollection = async () => {
    try {
      const payload = {
        class: data?.idval,
        collection: data?.selectedCollectionId,
      };
      const res = await dispatch(ClassCollectionDeleteAction(payload));
      if (res?.payload?.statusCode == 200) {
        toast.success("Collection Deleted Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        dispatch(classdetailsAction(data?.idval));
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResetAdminPassword = async () => {
    try {
      data = {
        id: data._id,
        email: data.email,
      };
      const res = await dispatch(adminResetPassAction(data?.id));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  const handleResetPassword = async () => {
    try {
      data = {
        id: data._id,
        email: data.email,
      };
      const res = await dispatch(teacheResetPassAction(data));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleChangeRoleToAdmin = async () => {
    try {
      const value = {
        permissionToUpdateYearGroups: canUpdateYearGroups,
        permissionToManageAdmins: canManageAdmins,
        id: data._id,
        switchedIntoSchoolAdmin: true,
      };
      const res = await dispatch(teacherChangeRoleAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/teachers");
        toast.success("Role Changed Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleChangeRoleToTeacher = async () => {
    try {
      const value = {
        id: data._id,
        switchedIntoTeacher: true,
      };
      const res = await dispatch(adminChangeRoleAction(value));
      if (res?.payload?.statusCode == 200) {
        navigate("/manage-admin");
        toast.success("Role Changed Successfully", {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResetStudentPassword = async () => {
    try {
      data = {
        id: data._id,
        email: data.email,
      };
      const res = await dispatch(studentResetPasswordAction(data));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleResetParentPassword = async () => {
    try {
      data = {
        id: data._id,
        // email: data.email,
      };
      const res = await dispatch(parentResetPasswordAction(data));
      if (res?.payload?.statusCode == 200) {
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
        handleConfirmClose();
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleDeleteStudent = async () => {
    try {
      const res = await dispatch(studentDeleteAction(data));
      if (res?.payload?.statusCode == 200) {
        navigate("/students");
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleClassDetailDelete = async () => {
    try {
      const payload = {
        id: data,
      };
      const res = await dispatch(ClassDeleteAction(payload));
      if (res?.payload?.statusCode == 200) {
        navigate("/classes");
        toast.success(res?.payload?.message, {
          iconTheme: {
            primary: "#4318ff",
            secondary: "#FFFAEE",
          },
        });
      } else {
        toast.error(res?.payload?.message);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const sensitiveContent = () => {
    extraFunction();
  };

  return (
    <Modal show={isModalOpen} onHide={handleConfirmClose}>
      <Modal.Header className="d-block" style={{ border: "0" }}>
        {selectedType === "deleteTecher" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to delete this teacher ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "sensitiveContent" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  <Modal.Title>Just so you know:</Modal.Title>
                  <p className="m-0">
                    Some content in the collection will be inaccessible to the
                    learner(s) as it falls outside their Key Stage.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "deleteOthersCollection" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  <Modal.Title>
                    {" "}
                    Are you sure you want to remove this collection?
                  </Modal.Title>
                  <p className="m-0">
                    A collection you’re removing from this class was added by
                    another teacher. This change will affect the class for you
                    and any other teachers that share this class.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "suspendTecher" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to suspend this teacher ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "suspendAdmin" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to suspend this admin ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "deleteAdmin" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to delete this Admin ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "teacherToAdmin" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div style={{ textAlign: "center" }}>
                <p className="m-0">
                  Are you sure you want to change this user’s role? For security
                  reasons, this will prompt the user to reset their password
                  before accessing the Admin Portal.
                </p>
                <div className="converting-sec">
                  {/* Permission: Update Year Groups */}
                  <Form.Group
                    className="mb-3"
                    controlId="permissionToUpdateYearGroups"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "12px",
                      }}
                    >
                      <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                        Allow this Admin to change a Learner’s Year Group
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="permissions-switch1"
                        name="permissionToUpdateYearGroups"
                        className="mt-1"
                        checked={canUpdateYearGroups}
                        onChange={(e) =>
                          setCanUpdateYearGroups(e.target.checked)
                        }
                        style={{
                          transform: "scale(1.5)",
                          transformOrigin: "right center",
                          marginLeft: "20px",
                        }}
                      />
                    </div>
                  </Form.Group>

                  {/* Permission: Manage Admins */}
                  <Form.Group
                    className="mb-3"
                    controlId="permissionToManageAdmins"
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "24px",
                      }}
                    >
                      <Form.Label style={{ marginBottom: 0, fontSize: "12px" }}>
                        Allow this Admin to create and manage Admins
                      </Form.Label>
                      <Form.Check
                        type="switch"
                        id="permissions-switch2"
                        name="permissionToManageAdmins"
                        className="mt-1"
                        checked={canManageAdmins}
                        onChange={(e) => setCanManageAdmins(e.target.checked)}
                        style={{
                          transform: "scale(1.5)",
                          transformOrigin: "right center",
                          marginLeft: "20px",
                        }}
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "adminToTeacher" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  <p className="m-0">
                    Are you sure you want to change this user’s role? For
                    security reasons, this will prompt the user to reset their
                    password before accessing the Teacher Portal.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "deleteCollection" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to delete this Collection ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {(selectedType === "resPassword" ||
          selectedType === "resAdminPassword") && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    Are you sure you want to issue a password reset?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "deleteStudent" && (
          <Row>
            {/* <Col lg={8} className="d-flex justify-content-end mt-4">
              <div>
                <Modal.Title>Are you sure ?</Modal.Title>
              </div>
            </Col> */}
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  <p className="m-0">
                    Are you sure you want to delete this learner ?
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "deleteOrganisationMember" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  <p className="m-0">
                    {message ||
                      "Are you sure you want to delete this organisation member ?"}
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "studentResetPassword" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    {" "}
                    Are you sure you want to issue a password reset? This
                    learner will be sent an email inviting them to reset their
                    password.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "parentResetPassword" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are You Sure ?</Modal.Title> */}
                  <p className="m-0">
                    {" "}
                    Are you sure you want to issue a password reset? This parent
                    will be sent an email inviting them to reset their password.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "ClassDetailDelete" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div>
                <div style={{ textAlign: "center" }}>
                  {/* <Modal.Title>Are you sure you want to delete this class?</Modal.Title> */}
                  <p>
                    You won’t be able to recover it once you do – you’ll have to
                    create it again from scratch.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        )}

        {selectedType === "requestAccess" && (
          <Row>
            <Col lg={12} className="d-flex justify-content-center pt-4">
              <div style={{ textAlign: "center" }}>
                <p className="m-0 small">{message}</p>
              </div>
            </Col>
          </Row>
        )}
      </Modal.Header>
      <Modal.Footer className="border-none justify-content-center pb-4 pt-0">
        <Button
          variant="secondary "
          className="modal-close-btn"
          onClick={handleConfirmClose}
        >
          {selectedType === "deleteOthersCollection" ? "Cancel" : "No"}
        </Button>
        {selectedType === "deleteTecher" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleDelete}
          >
            Yes
          </Button>
        )}
        {selectedType === "suspendTecher" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleSuspend}
          >
            Yes
          </Button>
        )}

        {selectedType === "suspendAdmin" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            // onClick={handleSuspend}
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteCollection" && (
          <Button
            variant="primary"
            className="modal-f-btn-del"
            onClick={handleDeleteCollection}
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteAdmin" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleDeleteAdmin}
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteOthersCollection" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleDeleteOthersCollection}
          >
            Ok
          </Button>
        )}

        {selectedType === "resAdminPassword" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleResetAdminPassword}
          >
            Yes
          </Button>
        )}
        {selectedType === "resPassword" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleResetPassword}
          >
            Yes
          </Button>
        )}

        {selectedType === "teacherToAdmin" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleChangeRoleToAdmin}
          >
            Yes
          </Button>
        )}

        {selectedType === "adminToTeacher" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleChangeRoleToTeacher}
          >
            Yes
          </Button>
        )}

        {selectedType === "studentResetPassword" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleResetStudentPassword}
          >
            Yes
          </Button>
        )}

        {selectedType === "parentResetPassword" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleResetParentPassword}
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteStudent" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={handleDeleteStudent}
          >
            Yes
          </Button>
        )}

        {selectedType === "deleteOrganisationMember" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={sensitiveContent}
          >
            Yes
          </Button>
        )}

        {selectedType === "ClassDetailDelete" && (
          <Button
            variant="primary"
            className="modal-f-btn-del"
            onClick={handleClassDetailDelete}
          >
            Yes
          </Button>
        )}

        {selectedType === "sensitiveContent" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={sensitiveContent}
          >
            Yes
          </Button>
        )}

        {selectedType === "requestAccess" && (
          <Button
            variant="primary"
            className="modal-f-btn"
            onClick={sensitiveContent}
          >
            Yes
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
